// extracted by mini-css-extract-plugin
export var subtitle = "_dc-2";
export var title = "_dc-0";
export var titleNoWrap = "_dc-1";